import Reveal from '@/components/base/Reveal';
import { timeline } from '@/mocks/home';

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[300px_1fr] gap-10 lg:gap-16">
          <Reveal className="lg:sticky lg:top-28 self-start">
            <span className="text-xs md:text-sm tracking-[0.2em] text-accent-600">ARCHIVE · 口述快讯流</span>
            <h3 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
              亲历者时间线
            </h3>
            <p className="mt-4 text-sm leading-7 text-foreground-600">
              以时间为轴，把<strong className="font-semibold text-foreground-900">缅北黑料讲述</strong>与
              <strong className="font-semibold text-foreground-900">缅北黑料经历</strong>
              拆成一个个可核对的节点，看清诱骗是如何一步步发生的。
            </p>
            <a
              href="#stories"
              className="mt-6 inline-flex items-center gap-2 h-11 px-5 rounded-md bg-secondary-500 text-background-50 text-sm font-medium hover:bg-secondary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看经历细节
              <i className="ri-arrow-down-line"></i>
            </a>
          </Reveal>

          <div className="relative">
            <div className="absolute left-[7px] top-2 bottom-2 w-px bg-background-300"></div>
            <ul className="flex flex-col gap-4">
              {timeline.map((item, index) => (
                <Reveal key={item.title} delay={index * 50}>
                  <li className="relative pl-8">
                    <span className="absolute left-0 top-6 w-[15px] h-[15px] flex items-center justify-center rounded-full border-2 border-accent-500 bg-background-50">
                      <span className="w-[5px] h-[5px] rounded-full bg-accent-500"></span>
                    </span>
                    <article className="rounded-lg bg-background-100 border border-background-200 p-5 hover:border-accent-300 transition-colors">
                      <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
                        <time className="text-xs font-semibold tracking-wide text-accent-700">{item.date}</time>
                        <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900">
                          {item.tag}
                        </span>
                        <span className="text-xs text-foreground-500">{item.narrator}</span>
                      </div>
                      <h4 className="mt-3 font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug">
                        {item.title}
                      </h4>
                      <p className="mt-2 text-sm leading-7 text-foreground-600">{item.summary}</p>
                    </article>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}